import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@nextui-org/react";
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import RatingNumber from "./RatingNumber";
import addRating from "../firebase/addRating";
import getRatings from "../firebase/getRatings";


const ModalComponent = ({ isOpen, onClose, whiskey, user, rating, setRating, ratings1, ratings2, ratings3, calculateOverallRatingAndComments, setRatings, ratings }) => {
  const [backdrop, setBackdrop] = useState('opaque')
  const navigate = useNavigate()
  const [number1, setNumber1] = useState([1, 2, 3, 4, 5])
  const [number2, setNumber2] = useState([1, 2, 3, 4, 5])
  const [number3, setNumber3] = useState([1, 2, 3, 4, 5])
  const [selectedNumber1, setSelectedNumber1] = useState(null)
  const [selectedNumber2, setSelectedNumber2] = useState(null)
  const [selectedNumber3, setSelectedNumber3] = useState(null)
  // const [rating, setRating] = useState(1);
  const [dateEnding, setDateEnding] = useState(":a")
  const [_date, set_date] = useState(new Date(whiskey.date.seconds * 1000).getDate())

  useEffect(() => {
    setEndingOfDate(_date)
    set_date(new Date(whiskey.date.seconds * 1000).getDate())
    getWhiskeyRatings()


  }, [_date, whiskey.date.seconds])


  // const handleRatingChange = (newRating) => {
  //   if (newRating >= 1 && newRating <= 5) {
  //     setRating(newRating);
  //   }
  // };

  const getWhiskeyRatings = async () => {
    // const { ratings1, ratings2, ratings3, score } = await getRatings(whiskey.id)
    // setRating(Math.round(score * 10) / 10)
    if (!ratings1.find(r => { return r.userId === user.id })) {
      return
    }
    else {
      setSelectedNumber1(ratings1.find(r => { return r.userId === user.id }).score)

    }
    if (!ratings2.find(r => { return r.userId === user.id })) {
      return
    }
    else {
      setSelectedNumber2(ratings2.find(r => { return r.userId === user.id }).score)

    }
    if (!ratings3.find(r => { return r.userId === user.id })) {
      return
    }
    else {
      setSelectedNumber3(ratings3.find(r => { return r.userId === user.id }).score)

    }
  }

  // const _date = new Date(whiskey.date.seconds * 1000).getDate()

  const setEndingOfDate = () => {
    switch (_date) {
      case 1:
        setDateEnding(":a")
        break;
      case 2:
        setDateEnding(":a")
        break;
      case 21:
        setDateEnding(":a")
        break;
      case 22:
        setDateEnding(":a")
        break;
      default:
        setDateEnding(":e")
        break;
    }
  }

  const handleOnClick = async (e, type) => {
    const _selectedNumber = Number(e.target.textContent)

    switch (type) {
      case 1:
        if (selectedNumber1 === _selectedNumber) {
          setSelectedNumber1(null)
        }
        else {

          setSelectedNumber1(_selectedNumber)
        }
        break;
      case 2:
        if (selectedNumber2 === _selectedNumber) {
          setSelectedNumber2(null)
        }
        else {

          setSelectedNumber2(_selectedNumber)
        }
        break;

      default:
        if (selectedNumber3 === _selectedNumber) {
          setSelectedNumber3(null)
        }
        else {

          setSelectedNumber3(_selectedNumber)
        }
        break;
    }
    await addRating(_selectedNumber, user.id, whiskey.id, type)
    // let ratingObject = {score: _selectedNumber, userId: user.id, whiskeyId: whiskey.id, type: type}
    // updateRatings(ratingObject)
    // const { ratings1, ratings2, ratings3, score } = await getRatings(whiskey.id)
    // setRating(Math.round(score * 10) / 10)
    if (!ratings1.find(r => { return r.userId === user.id })) {
      return
    }
    else {
      setSelectedNumber1(ratings1.find(r => { return r.userId === user.id }).score)

    }
    if (!ratings2.find(r => { return r.userId === user.id })) {
      return
    }
    else {
      setSelectedNumber2(ratings2.find(r => { return r.userId === user.id }).score)

    }
    if (!ratings3.find(r => { return r.userId === user.id })) {
      return
    }
    else {
      setSelectedNumber3(ratings3.find(r => { return r.userId === user.id }).score)

    }
    console.log("done")
  }

  // const updateRatings = (_rating) => {
  //   console.log(_rating)
  //   console.log(ratings)
  //   console.log(ratings.filter(r => r.type === _rating.type && r.userId === _rating.userId))

    
  // }
  






  return (
    <>

      <Modal backdrop={backdrop} isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody className="">
                <ModalHeader className="flex flex-col text-sm sm:text-md text-white px-0 pb-0">{_date}{dateEnding} December</ModalHeader>
                <div className="flex justify-between gap-3">
                  <div className="basis-3/5 flex flex-col gap-8">
                    <div className="flex flex-col justify-start">

                      <ModalHeader className="flex text-sm sm:text-lg flex-col text-gray-600 py-0 px-0 pb-0">{whiskey.origin}</ModalHeader>
                      <ModalHeader className="flex text-sm sm:text-lg flex-col text-white px-0 py-0">{whiskey.name}</ModalHeader>
                      <ModalHeader className="flex text-sm sm:text-lg flex-col text-gray-400 px-0 py-0">{whiskey.subName}</ModalHeader>
                    </div>
                    <div>

                      <span className="text-sm sm:text-xl text-white w-full mt-2 sm:mt-4 font-bold">Beskrivning</span>
                      <p className="text-gray-400 text-xs sm:text-sm">
                        {whiskey.shortDetails}
                      </p>
                    </div>
                  </div>
                  <img
                    alt="Card background"
                    className="basis-2/5 object-contain w-60 max-h-48 sm:max-h-80 rounded-xl mt-4 sm:mt-8 justify-self-end self-end"
                    src={whiskey.image}
                  />
                </div>


                <div className="flex justify-between flex-col w-full items-center">
                  <span className="text-sm sm:text-xl text-white w-full mt-4 font-bold">Betygsätt</span>
                  <div className="flex justify-between w-full mt-1 flex-col items-start">
                    <span className="text-xs sm:text-md text-white w-20 mt-1 sm:mt-4 font-bold border-b border-gray-800 mb-2">Doft</span>
                    <div className="flex justify-evenly w-full">
                      {number1.map((n) =>
                        <RatingNumber handleOnClick={handleOnClick} type={1} selectedNumber={selectedNumber1} number={n} key={n} />
                      )}
                    </div>
                    <span className="text-xs sm:text-md text-white w-20 mt-1 sm:mt-4 font-bold border-b border-gray-800 mb-2">Smak</span>
                    <div className="flex justify-evenly w-full">
                      {number2.map((n) =>
                        <RatingNumber handleOnClick={handleOnClick} type={2} selectedNumber={selectedNumber2} number={n} key={n} />
                      )}
                    </div>
                    <span className="text-xs sm:text-md text-white w-20 mt-1 sm:mt-4 font-bold border-b border-gray-800 mb-2">Avslutning</span>
                    <div className="flex justify-evenly w-full">
                      {number3.map((n) =>
                        <RatingNumber handleOnClick={handleOnClick} type={3} selectedNumber={selectedNumber3} number={n} key={n} />
                      )}
                    </div>

                  </div>
                  <h2 className="mt-4 font-bold text-sm sm:text-xl dark:text-white w-full">Betyg</h2>

                  <div className='mt-2 flex  dark:text-white flex-col w-full'>
                    <span className="text-xs sm:text-sm text-gray-400">{!rating ? "-" : rating} / 5</span>
                  </div>

                </div>


                {/* <div className="mt-4">
                  <h4 className="dark:text-white">Kommentarer</h4>
                  <div className="flex gap-3 flex-col mt-2">
                    <Comment />
                    <Comment />
                  </div>
                  <div className="col-span-full">
                    <label htmlFor="about" className="block text-sm font-medium leading-6 text-gray-900">
                      About
                    </label>
                    <div className="mt-2">
                      <textarea
                        id="about"
                        name="about"
                        rows={3}
                        className="block w-full rounded-md border-0 py-1.5 px-1.5 dark:text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder='Skriv en kommentar..'
                      />
                    </div>
                    <button
                      type="submit"
                      className="rounded-md mt-2 bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Skicka
                    </button>
                  </div>
                </div> */}
              </ModalBody>
              <ModalFooter className="flex justify-between px-6 py-4 mb-2" >
                <Button className="bg-gray-700 hover:bg-gray-600" onClick={() => navigate(`whiskey/${whiskey.id}`)}>
                  Läs mer

                </Button>
                <Button color="danger" variant="light" onClick={onClose}>
                  Stäng
                </Button>

              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}

export default ModalComponent